const SupportPage = () => {
  return <div>ss</div>;
};

export default SupportPage;
